import * as go from 'gojs';

export const getLink = (diagram: go.Diagram, link: go.ObjectData) => {
    const from = diagram.findNodeForKey(link.from);
    const to = diagram.findNodeForKey(link.to);

    return from.findLinksTo(to).first();
};
